import { useTranslation } from 'react-i18next';
import './Notifications.css';

function NotificationsHeader({
  onReadAll,
  unreadOnly = false,
  onUnreadFilterChange,
}) {
  const { t } = useTranslation();

  return (
    <div className="not-header-block">
      <div className="not-header-wrapper">
        <span className="not-header-title">{t('notifications.title')}</span>
        <span className="not-header-text" onClick={onReadAll}>
          {t('notifications.markAllAsRead')}
        </span>
      </div>
      <div className="not-filter-row">
        <button
          type="button"
          className={`not-filter-btn ${!unreadOnly ? 'active' : ''}`}
          onClick={() => onUnreadFilterChange?.(false)}
        >
          {t('all')}
        </button>
        <button
          type="button"
          className={`not-filter-btn ${unreadOnly ? 'active' : ''}`}
          onClick={() => onUnreadFilterChange?.(true)}
        >
          {t('notifications.unread')}
        </button>
      </div>
    </div>
  );
}

export default NotificationsHeader;
